import React from "react";
import "./listAssociation.scss";

import CardAssociation from "../../../../components/cardAssociation/CardAssociation";

import { Stack } from "react-bootstrap";
import { isEmpty } from "../../../../utils/validation";

const ListAssociations = ({
  width = 310,
  data,
  title,
  titleFontWeigth,
  selected,
  setSelected,
  disabled = false,
}) => {
  return (
    <div style={{ width }}>
      <Stack gap={3}>
        <h3 style={{ fontWeight: titleFontWeigth }} className="text-center">
          {title}
        </h3>
        <Stack gap={2}>
          {!isEmpty(data)
            ? data.map((item, index) => (
                <CardAssociation
                  key={index}
                  idAssociation={item.id}
                  name={item.name}
                  image={
                    item.image
                      ? "data:" + item.image_type + ";base64," + item.image
                      : "/no_img.png"
                  }
                  setSelected={setSelected}
                  selected={selected}
                  disabledSelection={disabled}
                />
              ))
            : null}
        </Stack>
      </Stack>
    </div>
  );
};

export default ListAssociations;
